import axios from 'axios';
import { StateType } from '../interface/CommonTypes';
import { ICard, ICardList } from '../interface/ICardList';
import store from './Store';
import Signal from '../libs/Signal';
import { ISignal } from '../libs/Signal';

export default class CardDataStore {

    private static _instance: CardDataStore;

    private readonly onLoad = new Signal<CardDataStore, StateType>();
    private readonly updateCards = new Signal<CardDataStore, Array<ICard>>();

    public static readonly LOAD_PENDING: StateType = 'pending';
    public static readonly LOAD_DONE: StateType = 'done';
    public static readonly LOAD_ERROR: StateType = 'error';

    private _cardData!: ICardList;

    public static get instance() {
        return this._instance || (this._instance = new this())
    }

    public get cardData(){
        return this._cardData;
    }

    public get LoadEvents(): ISignal<CardDataStore, StateType>{
        return this.onLoad.expose();
    }

    public get updateEvents(): ISignal<CardDataStore, Array<ICard>>{
        return this.updateCards.expose();
    }
    
    public async getData(_year:string = '0000', _category:string = 'ALL') {
        const comm = store.CommonDataStore;
        try {
            this.onLoad.trigger(this, CardDataStore.LOAD_PENDING);

            let paramData: {[propName: string]: string|number} = {
                displayCount: 9,
                productId: comm.config.productId,
                country: comm.config.country,
                page: store.CommonDataStore.nowPage,
            }

            paramData = this.addObjParam((_year !== '0000'), paramData, {categoryId: `Y${_year}`});
            paramData = this.addObjParam(!!(comm.config.optionalCategoryId), paramData, {optionalCategoryId: comm.config.optionalCategoryId});
            paramData = this.addObjParam(comm.config.useCategorySelect, paramData, {optionalCategoryId: _category});
            paramData = this.addObjParam((paramData.optionalCategoryId === 'ALL'), paramData, {optionalCategoryId: ''});

            const res = await axios.get(`${comm.config.apiUrl}/list`,{params: paramData});
            this._cardData = res.data;
            comm.isLast = this._cardData.last;

            this.updateCards.trigger(this, this._cardData.contents);
            this.onLoad.trigger(this, CardDataStore.LOAD_DONE);

        } catch (e) {
            this.onLoad.trigger(this, CardDataStore.LOAD_ERROR);
        }

        let pd: {[key: string]: string | number} ={
            displayCount: 9,
            productId: comm.config.productId,
        }
    }

    addObjParam<T, U>(_verify:boolean, _obj: T, _value: U): T{
        if (_verify) {
            return {
                ..._obj,
                ..._value
            }
        } else {
            return _obj;
        }
    }

} // end of class